// A timber harbour: a stone footing carrying a plank deck out over the water,
// finished with mooring bollards and a harbourmaster's hut. Ported 1:1 from
// age-of-mcp's harbour.ts: a local deck() generator plus the shared
// foundationSlab/scaffold helpers.
import * as THREE from "three";
import { defineModel, foundationSlab, scaffold, type Part } from "../../lib";

const DECK = "#9a7448";
const PILING = "#5e4528";
const BOLLARD = "#42351f";
const HUT = "#8a5a32";
const ROOF = "#5f3a1c";

const DECK_Y = 0.36;

function deck(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.BoxGeometry(1.84, 0.12, 1.84), color: DECK,
      position: [0, DECK_Y, 0] },
  ];
  for (const [x, z] of [[-0.72, -0.72], [0.72, -0.72], [-0.72, 0.72], [0.72, 0.72]]) {
    parts.push({
      geometry: new THREE.CylinderGeometry(0.09, 0.09, DECK_Y, 5),
      color: PILING, position: [x!, DECK_Y / 2, z!],
    });
  }
  return parts;
}

function partsFor(s: number): Part[] {
  if (s <= 0) return [foundationSlab(1.84)];
  if (s === 1) return [foundationSlab(1.84), ...scaffold(1.7, 0.6)];
  if (s === 2) return [foundationSlab(1.84), ...deck(), ...scaffold(1.7, 0.85)];

  const top = DECK_Y + 0.06;
  return [
    foundationSlab(1.84),
    ...deck(),
    { geometry: new THREE.CylinderGeometry(0.09, 0.11, 0.3, 6), color: BOLLARD,
      position: [-0.56, top + 0.15, 0.8] },
    { geometry: new THREE.CylinderGeometry(0.09, 0.11, 0.3, 6), color: BOLLARD,
      position: [0.32, top + 0.15, 0.8] },
    { geometry: new THREE.BoxGeometry(0.62, 0.56, 0.62), color: HUT,
      position: [-0.5, top + 0.28, -0.5] },
    { geometry: new THREE.BoxGeometry(0.78, 0.12, 0.78), color: ROOF,
      position: [-0.5, top + 0.62, -0.5] },
  ];
}

export const harbour = defineModel({
  id: "harbour",
  tiles: { w: 2, h: 2 },
  batchId: "standard",
  name: "Harbour",
  tags: ["building","harbour","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly harbour.",
  description: "A timber dock reaching out over the water from the shore.",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
